import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getProductFormattedNumber } from '../../../helpers/CurrencyUtils';
import { getProductAwardAmount, getProductDisplayName } from '../../../helpers/ProductUtils';

export default function ItemConvertSuccess({ selectedPackage, onClose }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div
      id="item-convert-success"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div className="modal-header">
            <h4>{t('item_convert_success')}</h4>
          </div>
          <div className="modal-body">
            <div className="row">
              <p className="col-xs-12">
                {
                  t('item_convert_success_text', {
                    amount: getProductFormattedNumber(getProductAwardAmount(selectedPackage)),
                    item: getProductDisplayName(selectedPackage),
                  })
                }
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-primary btn-full"
                onClick={onClose}
              >
                {t('item_convert_ok')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ItemConvertSuccess.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  selectedPackage: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
